// types
import type { DealHistory } from '@makemydeal/dr-dash-types';
import type { FC } from 'react';

// selectors
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { createDealRootSelector } from '../../offerCompareColumn/hooks/createDealRootSelector';

// components
import DealSummaryItem from '../common/DealSummaryItem';

// constants
import * as constants from '../../constants';

// utils
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

// hooks
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';
import { useHeldValue } from '../../hooks/useHeldSelector';

export type CashDueFromCustomerProps = {
    deal?: DealHistory;
};

const CashDueFromCustomer: FC<CashDueFromCustomerProps> = ({ deal }) => {
    const useDealRootSelector = createDealRootSelector(deal, 'CashDueFromCustomer');
    const cashDueFromCustomer = useHeldValue(
        useDealRootSelector(offerReduxSelectors.getCashDueFromCustomer, 'cashDueFromCustomer'),
        deal
    );
    const { showDetailedView } = useDealSummary();

    return (
        <DealSummaryItem
            label={constants.CASH_DUE_FROM_CUSTOMER}
            value={formatDollarsAndCents(cashDueFromCustomer)}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default CashDueFromCustomer;
